/* eslint-disable arrow-body-style */
// @flow
import type { HeadlineProps } from 'components/atoms/headline/react/Headline';
import Headline from 'components/atoms/headline/react/Headline';
import React from 'react';
import classNames from 'classnames';
import Button from 'components/atoms/button/Button';
import type { ButtonProps } from 'components/atoms/button/Button';

type Props = {
  children: React.Node,
  appearance?: 'default' | 'grid',
  headline?: HeadlineProps,
  button?: ButtonProps,
  className?: string,
};

const Accordion = ({
  children,
  headline,
  appearance,
  button,
  className,
}: Props): React$MixedElement => {
  return (
    <div
      className={classNames(
        'accordion',
        `accordion--${appearance || 'default'}`,
        className
      )}
    >
      {headline && (
        <div className="accordion__headline">
          <Headline {...headline} />
        </div>
      )}
      <div className="accordion__items" role="presentation">
        {children}
      </div>

      {button && (
        <div className="accordion__button">
          <Button {...button} />
        </div>
      )}
    </div>
  );
};

export default Accordion;
